import DecreaseDailyIncome from "./DecreaseDailyIncome"
import IncomeGaps from "./IncomeGaps"


const AnomaliesIncome = () => {
  return (
    <>
      <IncomeGaps/>
      <DecreaseDailyIncome/>
    </>
  )
}

export default AnomaliesIncome